/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { editorStore } from '@/context/store/store';
import { routeTree } from './routeTree.gen';
import { AuthProvider } from './context/auth/auth';
import { useAuth } from './hooks/useAuth';
import * as Sentry from '@sentry/react';
import './index.css';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: {
    auth: undefined!,
  },
});

Sentry.init({
  dsn: 'https://5f2220fb9c4d2bdd8e1e2aa343e740b5@o4510911985876992.ingest.de.sentry.io/4511098856276048',
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
});

const queryClient = new QueryClient();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function InnerApp() {
  const auth = useAuth();
  return <RouterProvider router={router} context={{ auth }} />;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={editorStore}>
        <AuthProvider>
          <InnerApp />
        </AuthProvider>
      </Provider>
    </QueryClientProvider>
  );
}

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
